module.exports = __webpack_public_path__ + "img/ind_agri.0db9b5f1.png";